const DevelopmentNewsBanner = () => {

    jQuery(document).ready(function($) {
        // Function to get cookie value by name
        function getCookie(name) {
            var cookies = document.cookie.split(';');
            for (var i = 0; i < cookies.length; i++) {
                var cookie = cookies[i].trim();
                if (cookie.indexOf(name) === 0) {
                    return cookie.substring(name.length + 1);
                }
            }
            return null;
        }
    
        // Function to set cookie with expiration date
        function setCookie(name, value, days) {
            var expiryDate = new Date();
            expiryDate.setDate(expiryDate.getDate() + days);
            document.cookie = name + '=' + value + '; expires=' + expiryDate.toUTCString() + '; path=/';
        }
    
        // Click event listener for closing the banner
        $('.development-news-banner__close').on('click', function() {
            var bannerID = $(this).closest('.development-news-banner').attr('id');
            $(this).closest('.development-news-banner').addClass('development-news-banner--closed');
            // Add closed class to body for page-wide effects
            $('body').addClass('development-news-banner-closed');
            // Store the state of the banner in cookie with bannerID as the key
            setCookie(bannerID, true, 7);
        });
    
        // Check if the banner should be closed based on cookie
        $('.development-news-banner').each(function() {
            var bannerID = $(this).attr('id');
            var isBannerClosedCookie = getCookie(bannerID);
            if (isBannerClosedCookie && isBannerClosedCookie === 'true') {
                $(this).addClass('development-news-banner--closed');
                // Add closed class to body for page-wide effects
                $('body').addClass('development-news-banner-closed');
            }
        });
    });
    
};

export default DevelopmentNewsBanner;